export const getIsWhatWeOfferOrCustomPagePreview = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const isInIFrame = window.self !== window.top;
  const isWhatWeOfferPreview = window.location.pathname.includes('what-we-offer') && Boolean(Object.keys(params).length) && isInIFrame;
  const isCustomHomePagePreview = window.location.search.startsWith('?') && Boolean(Object.keys(params).length) && isInIFrame;
  return isWhatWeOfferPreview || isCustomHomePagePreview;
};